





















































































import Vue from "vue";
import { authentication } from "@/stores";
import { Route } from "vue-router";
import { Coupon, Tenant, Announcement } from "@/models";
import { firestore } from "firebase/app";
import firebaseProject from "@/common/firebaseProject";
import { Collection, Document, List, DocDataRef } from "@/stores";
import { form, autoclose, shopBase } from "@/mixins";
import { alert, confirm } from "@/services/dialog";
import { generateDocumentId } from "@/common/generateDocumentId";
import dayjs from "dayjs";

const db = firebaseProject.firestore();

enum PageType {
  WAITING_APPROVAL = 1,
  ALL = 2
}

export default shopBase.extend(Vue).extend({
  name: "CouponDetail",
  mixins: [autoclose],
  data() {
    return {
      authentication,
      transitionName: "",
      modal_on: false,
      remandReason: ""
    };
  },
  computed: {
    collection(): Collection<Coupon> {
      const path = `/coupon`;
      return new Collection(
        db.collection(path) as firestore.CollectionReference<Coupon>
      );
    },
    tenantId(): string {
      return this.document.effective.tenantId
        ? this.document.effective.tenantId
        : "";
    },
    document(): Document<Coupon> {
      const id = this.$route.params.id;
      return this.collection.doc(id, { noListen: true });
    },
    pageType(): PageType {
      const stateFilter = this.$route.query.state;
      if (stateFilter && stateFilter == "waitingAuthorize") {
        return PageType.WAITING_APPROVAL;
      } else {
        return PageType.ALL;
      }
    },
    pageTitle(): string {
      return this.pageType == PageType.WAITING_APPROVAL
        ? "承認待ちクーポン"
        : "クーポン";
    }
  },
  methods: {
    makeRemand() {
      this.modal_on = true;
    },
    async confirmRemand() {
      const confirmed = await confirm({
        title: "確認",
        text: `以下の内容で差し戻します。\n${this.remandReason} \n\nよろしいですか？`
      });
      if (confirmed === true) {
        db.runTransaction(async transaction => {
          const announcePath = `/shop/${this.shopId}/announcement`;
          const announceRef = await db
            .collection(announcePath)
            .doc(generateDocumentId());
          const announce = await new Collection(
            db.collection(announcePath) as firestore.CollectionReference<
              Announcement
            >
          ).doc(announceRef.id);
          const promises = [];
          if (this.document.ref && announce.ref) {
            const documentRef = this.document.ref;
            promises.push(
              transaction.get(documentRef).then(() => {
                transaction.update(documentRef, {
                  authorizeStatus: 3,
                  authorizeComment: this.remandReason
                });
              })
            );
            const announceRef = announce.ref;
            promises.push(
              transaction.get(announceRef).then(() => {
                const title =
                  "クーポンの差し戻しがあります。確認して再登録してください。";
                transaction.set(announceRef, {
                  title: title,
                  viewableTenant: [this.tenantId],
                  couponId: this.document.id,
                  content: this.remandReason,
                  importantFlag: false,
                  discloseAt: this.now,
                  publishStatus: 2
                });
              })
            );
            return Promise.all(promises);
          } else {
            throw "クーポンデータが取得できないため更新できません。";
          }
        })
          .then(() => {
            this.modal_on = false;
            this.$router.push({ path: "/coupon", query: this.$route.query });
          })
          .catch(e => {
            console.log(e);
            alert({
              title: "エラー",
              text: "差し戻し時のデータ書き込みに失敗しました。"
            });
          });
      } else {
        this.modal_on = false;
      }
    },
    async approve() {
      const confirmed = await confirm({
        title: "確認",
        text: `この内容で承認します。\nよろしいですか？`
      });
      if (confirmed === true) {
        db.runTransaction(async transaction => {
          const announcePath = `/shop/${this.shopId}/announcement`;
          const announceRef = db
            .collection(announcePath)
            .doc(generateDocumentId());
          const announce = new Collection(
            db.collection(announcePath) as firestore.CollectionReference<
              Announcement
            >
          ).doc(announceRef.id);
          const promises = [];
          debugger;
          if (this.document.ref && announce.ref) {
            const documentRef = this.document.ref;
            let pushComment = "";
            if (
              this.document.effective.pushSend &&
              !this.document.effective.pushStatus &&
              dayjs(this.document.effective.pushAt).valueOf() < Date.now()
            ) {
              promises.push(
                transaction.get(documentRef).then(_doc => {
                  transaction.update(documentRef, {
                    authorizeStatus: 2,
                    authorizeComment: null,
                    pushSend: false
                  });
                })
              );
              pushComment =
                "承認時間が配信時間を過ぎていたため、プッシュ配信しない設定に変更されました。";
            } else {
              promises.push(
                transaction.get(documentRef).then(_doc => {
                  transaction.update(documentRef, {
                    authorizeStatus: 2,
                    authorizeComment: null
                  });
                })
              );
            }
            if (
              !this.document.effective.unlimited &&
              dayjs(this.document.effective.availableFrom).valueOf() > this.now
            ) {
              announce.effective.title = `クーポンが承認され、予約登録されました。${this.formatFullDate(
                this.document.effective.availableFrom || 0
              )}に投稿されます。変更がある場合は、配信前日の18時までにご連絡ください。削除はいつでも可能です。`;
            } else {
              announce.effective.title = "クーポンが承認されました。";
            }
            if (pushComment != "") {
              announce.effective.title += pushComment;
            }
            const _announceRef = announce.ref;
            promises.push(
              transaction.get(_announceRef).then(_announce => {
                transaction.set(_announceRef, {
                  title: announce.effective.title || "",
                  viewableTenant: [this.tenantId],
                  couponId: this.document.id,
                  content: announce.effective.title || "",
                  importantFlag: false,
                  discloseAt: this.now,
                  publishStatus: 2
                });
              })
            );
            return Promise.all(promises);
          }
        })
          .then(() => {
            alert({
              title: "確認",
              text: "クーポンを承認しました。"
            });
            this.modal_on = false;
            this.$router.push({ path: "/coupon", query: this.$route.query });
          })
          .catch(err => {
            console.error(err);
          });
      }
    }
  }
});
